import React from 'react';
import IconButton from 'components/common/IconButton';
import FalconCardHeader from 'components/common/FalconCardHeader';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

const Header = ({ toggelFilter, keyword, setKeyword }) => {
  return (
    <div>
      <FalconCardHeader
        title="Suppliers"
        light
        titleTag="h6"
        endEl={
          <div id="orders-actions" className="d-flex align-items-center">
            {/* 🔍 Search box */}
            <Form className="d-flex me-2">
              <Form.Control
                size="sm"
                type="text"
                placeholder="Search code or name..."
                value={keyword}
                onChange={e => setKeyword(e.target.value)}
              />
            </Form>

            {/* 🔄 Sync button */}
            <IconButton
              variant="falcon-default"
              size="sm"
              icon="sync-alt"
              transform="shrink-3"
              className="mx-2"
              onClick={toggelFilter}
            >
              <span className="d-none d-sm-inline-block ms-1">
                Sync Supplier
              </span>
            </IconButton>
          </div>
        }
      />
    </div>
  );
};

Header.propTypes = {
  toggelFilter: PropTypes.func,
  keyword: PropTypes.string,
  setKeyword: PropTypes.func,
};

export default Header;
